export class DialogModelAddOpenMedicineWarehouse {
    constructor(
        private billingKeys: any
    ) {}
  }